import { render, staticRenderFns } from "./VaccinationAnalysisChart.vue?vue&type=template&id=9fa8b452&"
import script from "./VaccinationAnalysisChart.vue?vue&type=script&lang=ts&"
export * from "./VaccinationAnalysisChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports